import { Bell, Bot, Info, ScrollText } from 'lucide-react'

interface ItemProps {
  icon: React.ComponentType<{ className?: string }>
  title: string
  children: React.ReactNode
}

function Item({ icon: Icon, title, children }: ItemProps) {
  return (
    <li className="flex gap-2.5 text-xs text-muted-foreground">
      <span className="flex h-[26px] w-[26px] flex-shrink-0 items-center justify-center rounded-md bg-secondary text-foreground">
        <Icon className="h-3.5 w-3.5" />
      </span>
      <span>
        <strong className="block font-semibold text-foreground">{title}</strong>
        {children}
      </span>
    </li>
  )
}

export default function HowItWorksCard() {
  return (
    <section className="rounded-xl border border-border bg-card shadow-sm">
      <div className="px-5 pt-4">
        <h3 className="flex items-center gap-2 text-[15px] font-semibold text-foreground">
          <Info className="h-4 w-4 text-muted-foreground" />
          Como funciona
        </h3>
      </div>
      <ul className="flex flex-col gap-3 p-5 pt-4">
        <Item icon={Bot} title="Agentes — canal padrão">
          A mensagem é injetada imediatamente no contexto de todas as sessões de usuário de cada agente, via
          gateway OpenClaw.
        </Item>
        <Item icon={Bell} title="Canais adicionais">
          Opcionalmente, os usuários das organizações selecionadas também recebem notificação no painel e/ou
          e-mail.
        </Item>
        <Item icon={ScrollText} title="Auditoria">
          Cada envio fica registrado no histórico com contagem de entregas e falhas por canal, e falhas podem
          ser reenviadas.
        </Item>
      </ul>
    </section>
  )
}
